import React from "react";
import { Link } from "react-router-dom";

const TITLE = "404";
const MESSAGE = "Sidan kunde inte hittas";
const LINK_TEXT = "Gå tillbaka till startsidan";

const TITLE_STYLES = "text-6xl font-bold text-white font-nunito";
const MESSAGE_STYLES = "text-xl text-white font-nunito mb-8";
const LINK_STYLES = "text-blue-500 underline";

const NotFoundPage: React.FC = () => {
  return (
    <main className="flex-grow h-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className={TITLE_STYLES}>{TITLE}</h1>
        <p className={MESSAGE_STYLES}>{MESSAGE}</p>
        <Link to="/" className={LINK_STYLES}>
          {LINK_TEXT}
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;
